import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import AccountActivationPending from '../screens/auth/components/AccountActivationPending';
import { useAuth } from '../hooks/useAuth';
import { isUserAccountActive } from '../utils/accessUtils';

interface ActivationGuardProps {
  children: React.ReactNode;
}

const ActivationGuard: React.FC<ActivationGuardProps> = ({ children }) => {
  const { loading } = useAuth();
  const user = useSelector((state: RootState) => state.user);

  // Пока идет инициализация — ничего не рендерим (даст Splash в корне)
  if (loading) {
    return null;
  }

  // Если пользователь не авторизован, показываем содержимое
  if (!user) {
    return <>{children}</>;
  }

  // Не is_active === true — страница ожидания (любая организация)
  if (!isUserAccountActive(user)) {
    return <AccountActivationPending />;
  }

  return <>{children}</>;
};

export default ActivationGuard;
